<template>
  <div class="flex">
    <NFormField
      label="Email"
      required
      name="email"
      description="We'll never share your email with anyone else."
    >
      <NInput
        placeholder="phojrengel@gmail.com"
        leading="i-heroicons-envelope-20-solid"
      />
    </NFormField>
  </div>
</template>
